module.exports = __webpack_public_path__ + "static/media/img-ask-to-apply@2x.980d311b.png";